import { z } from "zod";

export const MailTemplateFormSchema = z.object({
  name: z.string().min(1, "テンプレート名を入力してください"),
  body: z
    .string()
    .min(1, "本文を入力してください")
    .superRefine((val, ctx) => {
      if (!val.includes("{name}")) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "本文に{name}を含めてください",
        });
      }
    }),
});

export type MailTemplateFormData = z.infer<typeof MailTemplateFormSchema>;
